import type { SxProps, Theme } from '@mui/material';

export const personTimelineHeaderSx = {
  display: 'flex',
  flexDirection: 'row',
  marginRight: '15px',
  paddingRight: '3px',
  fontSize: '12px',
  height: '20px',
  alignItems: 'center',
} as const;

export const personTimelineActionNameSx = { paddingRight: '16px' } as const;

export const personTimelineDateSx = { marginRight: '7px', color: 'text.secondary' } as const;

export const getPersonTimelineIconSx = (isSystemNote = false, isHighlighted = false): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: isSystemNote
    ? isHighlighted
      ? 'text.primary'
      : 'text.secondary'
    : isHighlighted
      ? 'primary.dark'
      : 'primary.main',
  borderRadius: '50%',
  color: 'common.white',
  marginLeft: isHighlighted ? (isSystemNote ? '-7px' : '-5px') : '-2px',
  padding: isHighlighted ? (isSystemNote ? '10px' : '8px') : '6px',
  ...(isHighlighted && { boxShadow: '0 4px 4px var(--mui-palette-common-softBorder)' }),
  '& svg': { fontSize: isHighlighted ? (isSystemNote ? '22px' : '20px') : '18px' },
});

export const personTimelineStepContentSx = {
  padding: '6px 0 28px 26px',
  '& blockquote': {
    fontStyle: 'italic',
    padding: '11px 25px 11px 17px',
    margin: '0 0 20px',
    transform: 'translateY(10px)',
  },
  '&.MuiStepContent-root': { marginLeft: '13px' },
} as const;
